export default "__VITE_ASSET__Rg_3ssR6__"